import React, { useState, useEffect } from 'react';
import { XAFIISYADA_ITEMS } from '../../utils/constants';

const buildXafiisyadaCatalog = () =>
  XAFIISYADA_ITEMS.map((item) => ({
    itemName: item,
    damaged: false,
    quantity: 0
  }));

const GuristaXafiisyadaTable = ({ items = [], onChange, fullCatalog = false }) => {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (fullCatalog) {
      const savedByName = new Map(items.map((i) => [i.itemName, i]));
      setTableData(
        buildXafiisyadaCatalog().map((row) => ({
          ...row,
          ...(savedByName.get(row.itemName) || {})
        }))
      );
      return;
    }
    if (items.length > 0) {
      setTableData(items);
    } else {
      setTableData(buildXafiisyadaCatalog());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendChanges = (data) => {
    const allItems = data.map(({ mukayfText: _t, mukayfIc: _m, ...item }) => ({
      itemName: item.itemName,
      damaged: !!item.damaged,
      quantity: parseInt(item.quantity, 10) || 0
    }));
    onChange(allItems);
  };

  const handleCheckboxChange = (index) => {
    const newData = [...tableData];
    newData[index].damaged = !newData[index].damaged;
    setTableData(newData);
    sendChanges(newData);
  };

  const handleQuantityChange = (index, value) => {
    const newData = [...tableData];
    newData[index].quantity = parseInt(value, 10) || 0;
    setTableData(newData);
    sendChanges(newData);
  };

  return (
    <div className="overflow-x-auto border border-gray-200 rounded-lg">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-[#C62828] text-white">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider">
              Alaabta
            </th>
            <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wider">
              Dhaawacsan (Damaged)
            </th>
            <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wider">
              Tirada (Quantity)
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {tableData.map((row, index) => (
            <tr key={row.itemName} className="hover:bg-gray-50">
              <td className="px-4 py-3 text-sm font-semibold text-[#C62828]">{row.itemName}</td>
              <td className="px-4 py-3 text-center">
                <input
                  type="checkbox"
                  checked={row.damaged}
                  onChange={() => handleCheckboxChange(index)}
                  className="custom-checkbox"
                />
              </td>
              <td className="px-4 py-3 text-center">
                <input
                  type="number"
                  min="0"
                  value={row.quantity || ''}
                  onChange={(e) => handleQuantityChange(index, e.target.value)}
                  className="w-20 px-3 py-2 text-sm border border-gray-300 rounded text-center focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GuristaXafiisyadaTable;
